import { render, staticRenderFns } from "./CartTableItemRow.vue?vue&type=template&id=489cfa04&"
import script from "./CartTableItemRow.vue?vue&type=script&lang=js&"
export * from "./CartTableItemRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports